import React, { useState } from 'react';
import { toast } from 'react-toastify';
import style from './Register.module.css';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { userRegister } from '../../actions/user.action';
import { ValidateEmail } from '../../utils/ValidateEmail';

const Register = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [isOrg, setisOrg] = useState(false);
  const [password, setPassword] = useState('');

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const registerState = useSelector((state) => state.userRegisterReducer);
  const { loading, success, message } = registerState;

  const submitHandler = async (e) => {
    e.preventDefault();
    const user = { name, email, password, isOrg };
    if (name && email && password) {
      if (ValidateEmail(email))
        dispatch(userRegister(user));
    } else toast.error('Please fill the details!');
  };

  if (!loading && success) {
    toast.success('User registered!');
    navigate('/login');
  } else {
    toast.error(message);
  }

  return (
    <div className={style.Register}>
      <p>Start submitting bugs</p>
      <div className={style.details}>
        <p>Enter your details below to create an account.</p>
      </div>
      <div className={style.section}>
        <p>Username</p>
        <input
          type='text'
          value={name}
          placeholder='hunter123'
          onChange={(e) => setName(e.target.value)}
        />
      </div>
      <div className={style.section}>
        <p>Email</p>
        <input
          type='email'
          value={email}
          placeholder='hunter@hackerbro.in'
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
      <div className={style.section}>
        <p>Password</p>
        <input
          type='password'
          value={password}
          placeholder='Enter your password'
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>
      <div style={{ display: 'flex' }}>
        <input
          style={{ width: '20px', marginRight: '20px' }}
          value={isOrg}
          type='checkbox'
          onClick={() => setisOrg(!isOrg)}
        />
        <p style={{ fontSize: '15px' }}>Organisation</p>
      </div>
      <div className={style.Button} onClick={submitHandler}>
        Sign-up
      </div>
      <div className={style.Bottom}>
        <span>Already have an account?</span>
        <Link
          to='/login'
          className='link'
          style={{ color: 'rgb(161, 35, 161)' }}
        >
          {' '}
          Login here.
        </Link>
      </div>
    </div>
  );
};

export default Register;
